module.exports = __webpack_public_path__ + "6bf4379f53e176f9e44732b874f37afa.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-420.jpg
// module id = 292
// module chunks = 0